import type { SystemResource } from '@xianlaibang/shared/types'

export const sysApi = {
  // 获取系统资源
  getResources: async () => {
    const { get } = useHttp()
    return get<SystemResource[]>('/system/resources')
  },

  // 根据字典类型查询字典数据信息
  getDicts: async (dictType: string) => {
    const { get } = useHttp()
    return get<any>(`/system/dictData/type/${dictType}`)
  },

  // 获取基础配置
  getSysSetting: async (sysSetting: string) => {
    const { get } = useHttp()
    return get<any>(`/system/resources/${sysSetting}`)
  },

  // 获取协议
  getProList: async (protocolName: string) => {
    const { get } = useHttp()
    return get<any>(`/system/protocol/info/${protocolName}`)
  }
}
